// App-wide light/dark theme. The theme is a `data-theme` attribute on
// <html>; the shared design tokens (and the logo) cascade off it. Persisted
// to localStorage so the choice survives reloads and is shared between the
// marketing Landing page and the signed-in app.

export type Theme = 'light' | 'dark';

const THEME_KEY = 'openline.theme.v1';

/** Persisted choice, else dark (our flagship award-winning dark theme). */
export function readTheme(): Theme {
  try {
    const raw = localStorage.getItem(THEME_KEY);
    if (raw === 'light' || raw === 'dark') return raw;
  } catch {
    /* non-fatal — storage may be blocked */
  }
  return 'dark';
}

export function applyTheme(t: Theme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', t);
  }
}

/** Apply + persist in one call (used by the toggles). */
export function setTheme(t: Theme): void {
  applyTheme(t);
  try {
    localStorage.setItem(THEME_KEY, t);
  } catch {
    /* non-fatal */
  }
}
